import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0011',
    ecrans: ['00-2'],
    params: ['id',
            '?niveau',
            '?elecleint',
            '?unacleint',
            '?vaesysnatctb',
            '?anncivfin',
            '?peccoddeb',
            '?peccodfin',
            '?indcleint']
});
